import { FlowGraph } from '../FlowGraph';
import type { NodeId } from 'web';
import type { StickyNoteData } from '@/types/node';

export enum STICKY_NOTE_FONT_SIZE {
  SMALL = 16,
  MEDIUM = 24,
  LARGE = 32,
}

export const STICKY_NOTE_MAP_FONT_SIZE_TO_WIDTH: Record<STICKY_NOTE_FONT_SIZE, number> = {
  [STICKY_NOTE_FONT_SIZE.SMALL]: 240,
  [STICKY_NOTE_FONT_SIZE.MEDIUM]: 360,
  [STICKY_NOTE_FONT_SIZE.LARGE]: 480,
};

export const DEFAULT_STICKY_NOTE_COLOR = '#cc9de4'; // Purple_Lilac
export const DEFAULT_STICKY_NOTE_WIDTH = STICKY_NOTE_MAP_FONT_SIZE_TO_WIDTH[STICKY_NOTE_FONT_SIZE.SMALL];

export class StickyNoteView {
  constructor(
    private graph: FlowGraph,
    private nodeId: NodeId,
  ) {}

  updateColor(color: string): void {
    this.graph.edit(() => {
      return this.graph.updateNodeData(this.nodeId, { color });
    });
  }

  updateFontSize(fontSize: number): void {
    this.graph.edit(() => {
      return this.graph.store.updateNodeData<StickyNoteData>(this.nodeId, () => ({
        fontSize,
      }));
    });
  }

  updateNote(note: string): void {
    this.graph.edit(() => {
      return this.graph.store.updateNodeData<StickyNoteData>(this.nodeId, (data) => ({
        result: { ...(data.result ?? {}), note },
      }));
    });
  }

  getColor(): string | undefined {
    return this.graph.store.getNodeDataNullable<StickyNoteData>(this.nodeId)?.color;
  }

  getFontSize(): STICKY_NOTE_FONT_SIZE | undefined {
    return this.graph.store.getNodeDataNullable<StickyNoteData>(this.nodeId)?.fontSize;
  }
}
